'use client'

import { useState } from 'react'
import ProductModal from '@/components/ProductModal'

export default function ProductQuickOrder({ product, label = 'Быстрый заказ' }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button className="btn btn-primary" type="button" onClick={() => setOpen(true)}>
        {label}
      </button>
      {open && <ProductModal product={product} onClose={() => setOpen(false)} />}
    </>
  )
}
